/**
 * Efface le voile de lancement (le « Colette » qui respire, pose par index.html).
 *
 * Appele quand l'application est reellement prete : par App une fois la session
 * verifiee, ou par les pages publiques des leur montage.
 *
 * DUREE MINIMALE : le voile reste au moins 1,6 s a l'ecran, meme si tout est pret plus
 * tot. Retour du porteur sur la premiere version : « Colette s'affiche trop rapidement
 * et disparait » — un lancement instantane efface le moment de marque qu'il voulait.
 */
const DUREE_MINIMALE_MS = 1600;

declare global {
  interface Window {
    /** Pose par index.html au moment ou le voile apparait. */
    __voileDepuis?: number;
  }
}

export function masquerVoile(): void {
  const voile = document.getElementById('voile');
  if (voile === null) return;

  const depuis = window.__voileDepuis ?? Date.now();
  const restant = Math.max(0, DUREE_MINIMALE_MS - (Date.now() - depuis));

  window.setTimeout(() => {
    voile.classList.add('voile-fin');
    // Retire du DOM apres la transition d'opacite (0,4 s dans index.html).
    window.setTimeout(() => voile.remove(), 450);
  }, restant);
}
